import { UserEvaluationDelete } from 'Api/Request';
import { useState } from 'react';
import useTranslation from '../../../Hooks/useTranslation';

const useRestartEvaluation = (
  setOpenConfirmationModal,
  setAlertOpen,
  setAlertMessage,
  setAlertError,
  employees,
  setEmployees,
  courseId
) => {
  const [userToReset, setUserToReset] = useState();
  const { t2 } = useTranslation('Evaluation');

  const confirmationRestartEvaluation = (user, index) => {
    setUserToReset(user);
    setOpenConfirmationModal(true);
  };

  const restartEvaluation = () => {
    const response = UserEvaluationDelete({
      id: userToReset[7],
      userId: userToReset[6],
      courseId,
    });

    if (response) {
      setAlertMessage(t2('AlertRestartSuccess'));
      setAlertOpen(true);
      setEmployees(employees.filter(employee => employee[7] !== userToReset[7]));
    } else {
      setAlertMessage(t2('AlertRestartError'));
      setAlertOpen(true);
      setAlertError(true);
    }
  };

  return { confirmationRestartEvaluation, restartEvaluation };
};

export default useRestartEvaluation;
